import script from "./user-set.vue?vue&type=script&setup=true&lang=js"
export * from "./user-set.vue?vue&type=script&setup=true&lang=js"

import "./user-set.vue?vue&type=style&index=0&id=856b8e84&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-856b8e84"]])

export default __exports__